import httpRequest from 'superagent'
import qs from 'qs'

import * as Objects from 'helpers/Objects'

export default class base
{
    static sendAction({ origin = window.location.origin, namespace, action, data = false, type = 'get', progress = false })
    {
        const { api_origin = "" } = window

        origin = api_origin || origin || window.location.origin

        action = action != "" ? `/${action}` : action

        const url = `${origin}${namespace}${action}`

        return base.send({ url, data, type, progress })
    }

    static send({ url, data = false, type = 'get', progress = false })
    {
        return new Promise(( ok, fail ) => {
            let request = false

            if( type == 'get' )
            {
                request = httpRequest.get( url )
            } else if( type == 'post' )
            {
                request = httpRequest.post( url )
            } else if( type == 'xhr' )
            {
                request = httpRequest.post( url )
            } else if( type == 'delete' )
            {
                request = httpRequest.del( url )
            } else if( type == 'put' )
            {
                request = httpRequest.put( url )
            } else if( type == 'patch' )
            {
                request = httpRequest.patch( url )
            } else if( type == 'head' )
            {
                request = httpRequest.head( url )
            }

            if( data )
            {
                if( type == 'get' )
                {
                    request.query(
                        qs.stringify( data, {arrayFormat: 'brackets'})
                    )
                } else if( type == 'xhr' )
                {
                    Objects.each( data, ( key, value ) => {
                        if( value !== undefined )
                        {
                            if( value instanceof File )
                            {
                                request.attach( key, value )
                            } else
                            {
                                request.field( key, value )
                            }
                        }
                    })
                } else
                {
                    request.send( data )
                }
            }

            if( progress )
            {
                request.on( 'progress', params => {
                    progress( params.precent )
                })
            }

            if( window.allowBearerAuth )
            {
                request.set( "X-Authorization", "Bearer " + window.credenrialsBearerAuth )
            }

            if( window.allowBaseAuth )
            {
                console.log('UseBaseAuth::', window.credenrialsBaseAuth)

                request.auth( ...window.credenrialsBaseAuth.split( ":" ) )
            }

            request
                .set('Accept', 'application/json')
                .then(( res ) => {
                    if( res.status == 200 )
                    {
                        ok( res.body )
                    } else {
                        fail( res.status )
                    }
                })
                .catch( e => {
                    console.error( "Fail http request:" )
                    console.error( 'Params: ', { ...{ url, data, type, progress }} )
                    console.error( 'Error: ', e )

                    fail( e.message )
                })

            return request
        })
    }
}

export const createNamespace = ( namespace, originBase ) => ({ origin, action, data = null, type = 'get' }) => base.sendAction({ origin: origin || originBase, action, namespace, data, type })